export { NavigationInstrumentation } from './instrumentation';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/navigation/index.ts